<div class="sidenav">
  <ul class="menu" nz-menu nzTheme="dark" nzMode="inline">
    <div class="top-group">
      <div *ngIf="sidenavCollapsed" class="collapsed-items">
        <li nz-menu-item [ngClass]="{ 'margin-bottom-conditional': isAnySubmenuItemActive() || isSingleMenuActive() }">
          <img class="logo-img" src="assets\images\gains-icon-logo.png" alt="gains-logo" />
        </li>
        <div class="collapsed-menu" *ngFor="let item of sidenavMenu">
          <div *ngIf="isMenuItemActive(item) || isSubmenuItemActive(item)" class="menu-highlight-bar-collapsed"></div>
          <li nz-menu-item [class.selected]="isMenuItemActive(item) || isSubmenuItemActive(item)">
            <svg-icon [src]="item.icon" />
          </li>
        </div>
      </div>
      <div *ngIf="!sidenavCollapsed">
        <div class="logo-div">
          <img class="logo-img logo-img-positioned" nz-image nzSrc="assets\images\gains-icon-logo.png" alt="gains-logo" />
          <button type="button" class="logo-text-btn" aria-label="Text logo">
            <img class="logo-text" nz-image nzSrc="assets\images\text-logo.png" alt="Text logo" />
          </button>
        </div>
        <div class="menus">
          <div
            *ngFor="let item of sidenavMenu"
            [ngClass]="{
              'margin-left-active-main': !item.subMenu.length && isMenuItemActive(item),
              'margin-left-submenu-active': item.subMenu.length > 0 && isSubmenuItemActive(item),
              'margin-left-submenu-inactive': item.subMenu.length > 0 && !isSubmenuItemActive(item),
              'margin-left-default': !item.subMenu.length && !isMenuItemActive(item)
            }"
          >
            <div class="menu-item-div nosubmenu menu-hover" *ngIf="!item.subMenu.length" [class.active]="isMenuItemActive(item)">
              <div
                *ngIf="isMenuItemActive(item)"
                [ngClass]="{ 'main-menu-highlighter-positioned': isMenuItemActive(item), 'main-menu-highlighter-alt': !isMenuItemActive(item) }"
                class="main-menu-highlighter"
              ></div>
              <svg-icon
                [src]="item.icon"
                class="icon"
                [ngClass]="{
                  'icon-margin-active': isMenuItemActive(item),
                  'icon-margin-default': !isMenuItemActive(item),
                  'fill-icon': isMenuItemActive(item)
                }"
              />
              <li nz-menu-item [routerLink]="item.routerLink">
                {{ item.menu }}
              </li>
            </div>
            <div class="menu-item-div" *ngIf="item.subMenu.length > 0" [ngClass]="{ 'selected-submenu': isSubmenuItemActive(item) }">
              <li nz-submenu class="sub-menu" [nzOpen]="isSubmenuItemActive(item)">
                <div
                  class="sub-menu-title-template"
                  title
                  [ngClass]="{ 'submenu-title-margin-active': isSubmenuItemActive(item), 'submenu-title-margin-default': !isSubmenuItemActive(item) }"
                >
                  <div *ngIf="isSubmenuItemActive(item)" class="main-menu-highlighter main-menu-highlighter-alt"></div>
                  <svg-icon [src]="item.icon" class="icon submenu-icon-margin" [ngClass]="{ 'fill-icon': isSubmenuItemActive(item) }" />
                  <span [ngClass]="{ 'highlight-text-color': isSubmenuItemActive(item) }">{{ item.menu }}</span>
                </div>
                <ul *ngFor="let sub of item.subMenu">
                  <li
                    nz-menu-item
                    [routerLink]="sub.routerLink"
                    [ngClass]="{ 'submenu-item-margin-active': isSubmenuItemActive(item), 'submenu-item-margin-default': !isSubmenuItemActive(item) }"
                    class="menu-item ellipsis-text menu-hover"
                    *ngIf="sub.routerLink === '/home'"
                  >
                    {{ sub.name }}
                  </li>
                  <li
                    nz-menu-item
                    [routerLink]="sub.routerLink"
                    [ngClass]="{ 'submenu-item-margin-active': isSubmenuItemActive(item), 'submenu-item-margin-default': !isSubmenuItemActive(item) }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="menu-item ellipsis-text menu-hover"
                    *ngIf="sub.routerLink !== '/home'"
                  >
                    {{ sub.name }}
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-group" [ngClass]="{ 'bottom-group-padding': !sidenavCollapsed }">
      <hr [ngClass]="sidenavCollapsed ? 'hr-coll' : 'hr-exp'" />
      <div
        *ngFor="let item of bottomGroupMenu; trackBy: trackByMenu"
        [ngClass]="{
          'bottom-margin-left-active-main': isBottomMenuItemActive(item)
        }"
      >
        <div *ngIf="sidenavCollapsed" class="bottom-collapsed-items">
          <div class="bottom-collapsed-menu bottom-style-class">
            <div *ngIf="isBottomMenuItemActive(item)" class="bottom-menu-highlight-bar-collapsed"></div>
            <li
              nz-menu-item
              tabindex="0"
              [class.selected]="isBottomMenuItemActive(item)"
              [routerLink]="item.routerLink"
              [attr.aria-label]="item.menu"
              (click)="onRailItemActivated(item)"
              (keydown.enter)="onRailItemActivated(item)"
              (keydown.space)="onRailItemActivated(item); $event.preventDefault()"
            >
              <span class="bottom-menu-icon-wrap">
                <svg-icon [src]="item.icon" aria-hidden="true"></svg-icon>
                <gains-rail-item-badge
                  *ngIf="item.badgeKey"
                  class="bottom-menu-badge--collapsed"
                  [count]="getBadgeCount(item)"
                  [label]="item.menu"
                  [dot]="true"
                ></gains-rail-item-badge>
              </span>
            </li>
          </div>
        </div>
        <div
          *ngIf="!sidenavCollapsed"
          class="menu-item-div menu-hover bottom-style-class"
          [class.active]="isBottomMenuItemActive(item)"
          [class.inActive]="!isBottomMenuItemActive(item)"
        >
          <div *ngIf="isBottomMenuItemActive(item)" class="bottom-menu-highlight-bar"></div>
          <svg-icon
            [src]="item.icon"
            class="icon top-icon-margin"
            aria-hidden="true"
            [ngClass]="{ 'fill-icon': isBottomMenuItemActive(item), 'bottom-icon-selected': isBottomMenuItemActive(item) }"
          ></svg-icon>
          <li
            nz-menu-item
            tabindex="0"
            class="bottom-menu-padding"
            [routerLink]="item.routerLink"
            (click)="onRailItemActivated(item)"
            (keydown.enter)="onRailItemActivated(item)"
            (keydown.space)="onRailItemActivated(item); $event.preventDefault()"
          >
            {{ item.menu }}
          </li>
          <gains-rail-item-badge *ngIf="item.badgeKey" class="bottom-menu-badge" [count]="getBadgeCount(item)" [label]="item.menu"></gains-rail-item-badge>
        </div>
      </div>
      <div class="bottom-collapsed-items bottom-style-class" *ngIf="sidenavCollapsed">
        <li nz-menu-item class="user-icon-collapse"><svg-icon src="assets/icons/user.svg" class="icon" /></li>
      </div>
      <div class="bottom-collapsed-items bottom-style-class" *ngIf="sidenavCollapsed">
        <li nz-menu-item>
          <img [ngClass]="{ position: isSingleMenuActive() }" class="logo-img" nz-image nzSrc="assets\images\gains-logo-gray.png" alt="gains-logo" />
        </li>
      </div>
      <div class="menu-item-div menu-hover bottom-style-class inActive" *ngIf="!sidenavCollapsed">
        <svg-icon src="assets/icons/user.svg" class="icon bottom-icon-margin" />
        <li nz-menu-item class="user-menu-margin">{{ this.getFullName() }}</li>
        <gains-ellipsis-menu
          class="profile-ellipsis"
          [menuItems]="ellipsisDataItems"
          (changeEvent)="onEllipsisAction($event)"
          [dropdownWidth]="'254px !important'"
          [profileDropDownClass]="this.profileDropDownClass"
        ></gains-ellipsis-menu>
      </div>
      <div class="menu-item-div gains-version-section bottom-style-class" *ngIf="!sidenavCollapsed">
        <img class="logo-img bottom-logo-positioning" nz-image nzSrc="assets\images\gains-logo-gray.png" alt="gains-logo" />
        <li nz-menu-item class="gains-logo-section">
          <div class="outer-section">
            <div class="image-section">
              <img class="gray-logo-text" nz-image nzSrc="assets\images\gains-text-gray.png" alt="Gains text gray logo" />
            </div>
            <div class="version-div">
              {{ gainsVersion }}
              <img class="version-img" src="assets/icons/circle-question.svg" alt="Version icon" />
            </div>
          </div>
        </li>
      </div>
    </div>
  </ul>
</div>

<ng-template #logoutModalFooter>
  <div class="modal-footer-full-width">
    <button nz-button nzType="default" (click)="modalRef.close()" class="modal-footer-btn">Cancel</button>
    <button nz-button nzType="default" (click)="onLogout()" class="modal-footer-btn logout-btn">Log Out</button>
  </div>
</ng-template>
